<div class="flex items-center gap-1.5">
  <svg-icon
    [key]="icon()"
    class="max-h-[20px] max-w-[20px] text-text-light"
    [libUiTooltip]="iconTooltipKey() ? iconTooltipTpl : undefined"
    tooltipPosition="bottom"
  ></svg-icon>
  <h5 class="typo-h5-medium text-text-secondary">
    {{ displayText() | libPhoneFormat }}
  </h5>
</div>

<ng-template #iconTooltipTpl>
  <div class="typo-h7-light p-1">{{ iconTooltipKey()! | translate }}</div>
</ng-template>
